
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const UserCrudService = function(props: 
  CrudServiceProps<api.User,string>
) {
  
  return CrudApiService<api.User,string>({...props, api: api, entityName: 'User'});

};